import { render, staticRenderFns } from "./vuecommadl5.vue?vue&type=template&id=1c53c5f2&scoped=true"
import script from "./vuecommadl5.vue?vue&type=script&lang=js"
export * from "./vuecommadl5.vue?vue&type=script&lang=js"
import style0 from "./vuecommadl5.vue?vue&type=style&index=0&id=1c53c5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53c5f2",
  null
  
)

export default component.exports